import React from 'react';
import { CardFinish, FINISH_ORDER } from 'utils/finishes';
import { FinishTag } from 'components/FinishTag';
import { getPromoTreatments } from 'utils/promoTreatments';
import './FinishMarks.css';

interface FinishMarksProps {
  /** Finishes the printing exists in (from getAvailableFinishes) */
  finishes: readonly CardFinish[];
  /** Scryfall promo_types for the combined Finish column (addendum 2, 5.1) */
  promoTypes?: unknown;
  size?: 'sm' | 'md';
  className?: string;
}

/**
 * The combined "Finish" cell for a PRINTING row (Design Pass D-4, addendum 2):
 * one shared FinishTag per finish the printing exists in, canonical order. A
 * promo treatment is never its own chip: its swatch and muted name ride on the
 * printing's premium finish tag (the last in canonical order). Read-only.
 */
export const FinishMarks: React.FC<FinishMarksProps> = ({ finishes, promoTypes, size = 'md', className = '' }) => {
  const ordered = FINISH_ORDER.filter((f) => finishes.includes(f));
  const treatment = getPromoTreatments(promoTypes)[0] ?? null;
  const treatedIndex = ordered.length - 1;
  return (
    <span className={`finish-marks finish-marks--${size} ${className}`}>
      {ordered.map((f, i) => (
        <FinishTag key={f} finish={f} size={size === 'sm' ? 'tag' : 'cell'} treatment={i === treatedIndex ? treatment : null} />
      ))}
    </span>
  );
};

export default FinishMarks;
